import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { chatKeys } from '../../keys'
import chatService from '../services'

export function useMutationUpdateAiSetting() {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (data: {
			systemContext: string
			toolsEnabled?: Record<string, boolean>
			aiEnabled?: boolean
		}) => chatService.updateAiSetting(data),
		onSuccess: () => {
			toast.success('บันทึกการตั้งค่า AI แล้ว')
			queryClient.invalidateQueries({ queryKey: chatKeys.aiSetting() })
		},
		onError: () => {
			toast.error('บันทึกไม่สำเร็จ กรุณาลองใหม่')
		},
	})
}
